import React from "react";
const SingleLineStyle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "118",
    height: "1",
    viewBox: "0 0 118 1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("line", { x1: "0.5", y1: "0.5", x2: "117.5", y2: "0.5", stroke: "currentColor" })
);
var SingleLineStyle_default = SingleLineStyle;
export {
  SingleLineStyle_default as default
};
//# sourceMappingURL=SingleLineStyle.js.map
